import { useLocation } from 'react-router-dom';
import { GetDate, GetValidTillDate } from '../../../utils/Show';

function TopLeftCol({ info }) {
    const { timeIssue, id } = info?.invoice || {};
    const { organization, mobile, email, address, city, country } = info?.billingAddress || {};
    const { validity } = info?.invConfig || {};
    const { state } = useLocation();
    return (
        <div className="w-[calc(100%_-_370px)]">
            <div className="mb-5">
                <h2 className="text-5xl text-primary font-extrabold">
                    {' '}
                    {state?.title || 'INVOICE'}
                </h2>
                <p className="text-sm opacity-70">
                    <span>Invoice No : {id || 0}</span>
                </p>
            </div>

            <div className="mb-2 flex gap-4">
                <div>
                    <p className="text-sm opacity-70">Create Date</p>
                    <p className="text-lg font-extrabold leading-normal text-primary-700">
                        <span>{GetDate(timeIssue)}</span>
                    </p>
                </div>
                <div>
                    <p className="text-sm opacity-70">Valid Till</p>
                    <p className="text-lg font-extrabold leading-normal text-primary-700">
                        <span>{GetValidTillDate(timeIssue, validity)}</span>
                    </p>
                </div>
            </div>

            <div className="">
                <p className="text-sm opacity-70 leading-norma">Invoice to</p>
                <p className="text-lg font-extrabold leading-normal text-primary-700">
                    <span>{organization}</span>
                </p>
                <p className="text-sm opacity-70 font-normal">
                    <span>
                        {[address, city, country].filter((d) => !!d).join(', ') ||
                            '----------------------'}
                    </span>
                </p>
                <p className="text-sm opacity-70 font-normal">
                    {mobile || email ? ' Contact: ' : ''}
                    <span>
                        {[mobile, email].filter((d) => !!d).join(', ') || '----------------------'}
                    </span>
                </p>
            </div>
        </div>
    );
}

export default TopLeftCol;
